import config from '../config';
import instance from './axios-instance';

const STRAPI_API_URL = config.strapi.api_url + '/faq';

export const getQuestionCategories = () => {
    return instance.get(`${STRAPI_API_URL}/`);
}